import moment from 'moment'
import parseAddress from '@/utilities/address/parse'

let DEFAULT_FORM_VALUES = {
  lotFileDocumentID: 0,
  lotFileCategoryID: 0,
  owner: '',
  address: '',
  category: '',
  unitID: 0,
  ownerID: 0,
  documentID: 0,
  description: ''
}

let categoryList = [
  {
    label: 'All',
    filter: ''
  }
]

export const data = function() {
  return {
    DEFAULT_FORM_VALUES,
    formComplete: false,
    formData: {
      ...DEFAULT_FORM_VALUES
    },
    loading: true,
    isDebug: false,
    confirmModal: false,
    formatDateFn: function(value) {
      return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
    },
    formatFn: function(value) {
      return value != null ? value : ''
    },
    formatNumberFn: function(value) {
      return value != null ? value : 0
    },
    parsedAddress: function(value) {
      return parseAddress({ address: value })
    },
    pageCount: [],
    scale: 1,
    imageContent: null,
    documentName: '',
    attachment: false,
    documentFile: null,
    file: null,
    base64pdf: '',
    selectedRow: null,
    documentList: [{}],
    ownerID: null,
    unitID: null,
    selectedID: null,
    selectedDocument: '',
    formShow: false,
    action: '',
    hasPermission: false,
    showModal: false,
    filters: {
      show: true
    },
    rows: [],
    columns: [
      {
        field: 'id',
        label: 'ID',
        width: '5%',
        numeric: true,
        sortable: true,
        searchable: true
      },
      {
        field: 'category',
        label: 'Category',
        width: '20%',
        sortable: true,
        searchable: [...new Set(categoryList)]
      },
      {
        field: 'description',
        label: 'Description',
        width: '40%',
        sortable: true,
        searchable: true
      },
      {
        field: 'dateSubmitted',
        label: 'Date Submitted',
        width: '15%',
        numeric: true,
        sortable: true,
        searchable: true
      },
      {
        field: 'actions',
        label: 'Actions',
        width: '1%'
      }
    ]
  }
}
